export default __webpack_public_path__ + "static/circles_group-d8f43a51a98986d51e4bdbda10752d0b.jpg";